import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {

  @Input() query = '';
  @Output() queryChange = new EventEmitter<string>();
  selected = false;

  constructor(
    private translate: TranslateService,
  ) {
  }

  ngOnInit() { }

  onValueChanged(val: string) {
    this.query = val;
    this.queryChange.emit(this.query);
  }

}
